export default __webpack_public_path__ + "static/media/a020-ngo-1.a4f54e4e.svg";